import { render, staticRenderFns } from "./NewsProgramVideo.vue?vue&type=template&id=384ebe8f&"
import script from "./NewsProgramVideo.vue?vue&type=script&lang=js&"
export * from "./NewsProgramVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports